import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { CommonService } from './common-service.service';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private commonService: CommonService, private router: Router) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.commonService.sendRequestToNode({ method: 'post', path: 'auth/check-login' }).map(result => {
      if (!result.loginData) {
        this.router.navigate(['/auth/login']);
        return false;
      }
      let data = JSON.parse(result.loginData.UserPermission);

      if (data) {
        data = data.map(Number);
      }
      else {
        data = [];
      }


      if (route.data.access_role.indexOf(result.loginData.User_Type) != -1 && !route.data.hasOwnProperty('permission')) {
        return true;
      }
      else if (route.data.access_role.indexOf(result.loginData.User_Type) != -1 && route.data.hasOwnProperty('permission') && data.indexOf(route.data.permission) != -1) {
        return true;
      } else if (route.data.access_role.indexOf(result.loginData.User_Type) != -1 && route.data.hasOwnProperty('permission') && data.indexOf(route.data.permission) != -1) {
        return true;
      } else {
        this.router.navigate(['/dashboard']);
        return false;
      }
    })
  }
}


// export class AuthGuard implements  CanActivate, CanActivateChild {

//   constructor(private commonService: CommonService,private router: Router ) {}

//   canActivate(route: ActivatedRouteSnapshot,state: RouterStateSnapshot){
//     // console.log('i am checking to see if you are logged in');
//     // console.log(state)
//     let routeData = route.data || {};
//     console.log(routeData)
//     // if(routeData['module_id'])
//     // {
//     //   return this.commonService.sendRequestToNode({method :'get',path:'check-login'})
//     //   .map(data => {
//     //     if(data.status == true)
//     //         {
//     //           console.log(data)
//     //           // let loginData;
//     //           // loginData = JSON.stringify(data.loginData);
//     //           // localStorage.setItem(this.commonService.prefix+'userData', loginData);
//     //           // let permission = data.loginData.permission ? JSON.parse(data.loginData.permission) : {}
//     //           // if((data.loginData.role_id == 1) || routeData['module_id'] == 'common'){
//     //           //   return true;
//     //           // }
//     //           // else if(permission[routeData.parent_module_id] && permission[routeData.parent_module_id][routeData.module_id] && permission[routeData.parent_module_id][routeData.module_id]['view']){ // this for all accessible
//     //           //   return true;
//     //           // }
//     //           // else{
//     //           //   this.router.navigate(['dashboard']);

//     //           //   return false;
//     //           // }
//     //         }
//     //         else{
//     //             // return false;

//     //             // localStorage.removeItem(this.commonService.prefix+'userData');
//     //             this.router.navigate(['/login']
//     //             // {
//     //             //   queryParams: {
//     //             //     return: state.url
//     //             //   }
//     //             // }
//     //             );

//     //         }
//     //   })

//     // }
//     // else
//     // {
//     //   return true;
//     // }
//     return true;
//   }

//   canActivateChild() {
//     console.log('checking child route access');
//     return true;
//   }

// }
